/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuntimeListInfo,
    RuntimeListInfoFromJSON,
    RuntimeListInfoFromJSONTyped,
    RuntimeListInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface RuntimeListResponse
 */
export interface RuntimeListResponse {
    /**
     * 
     * @type {Array<RuntimeListInfo>}
     * @memberof RuntimeListResponse
     */
    list: Array<RuntimeListInfo>;
}

export function RuntimeListResponseFromJSON(json: any): RuntimeListResponse {
    return RuntimeListResponseFromJSONTyped(json, false);
}

export function RuntimeListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(RuntimeListInfoFromJSON)),
    };
}

export function RuntimeListResponseToJSON(value?: RuntimeListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(RuntimeListInfoToJSON)),
    };
}


